// extracted by mini-css-extract-plugin
export default {"Layout":"Layout_Layout__OK95Q","Content":"Layout_Content__upPLk"};